function localWorkflowAppUrl() {
  if (typeof window === 'undefined') return 'http://localhost:8790'
  const hostname = window.location.hostname === '::1'
    ? '[::1]'
    : window.location.hostname
  return `${window.location.protocol}//${hostname}:8790`
}

function normalizedUrl(value) {
  return String(value || '').trim().replace(/\/$/, '')
}

function isLoopbackUrl(value) {
  try {
    const target = new URL(value)
    return ['localhost', '127.0.0.1', '::1'].includes(target.hostname)
  } catch (error) {
    return false
  }
}

export function workflowAppUrl() {
  // 本地必须沿用主站当前主机名。localhost 和 127.0.0.1 的 Cookie 不互通，
  // 写死其中一个会让用户进入画布后被误判为未登录。
  if (process.env.NODE_ENV !== 'production') return localWorkflowAppUrl()

  const configuredUrl = normalizedUrl(process.env.VUE_APP_CANVAS_APP_URL)
  if (!configuredUrl || isLoopbackUrl(configuredUrl)) return ''
  return configuredUrl
}

export function safeWorkflowReturnUrl(value) {
  try {
    const workflowOrigin = new URL(requireWorkflowAppUrl()).origin
    const target = new URL(String(value || ''))
    return target.origin === workflowOrigin ? target.toString() : ''
  } catch (error) {
    return ''
  }
}

export function workflowOpenUrl(value) {
  const appUrl = new URL(requireWorkflowAppUrl())
  const requested = new URL(String(value || ''), appUrl)
  if (!['http:', 'https:'].includes(requested.protocol)) throw new Error('工作流项目地址无效')
  // 项目路径和参数使用后端返回值，主机始终使用浏览器当前选择的画布主机。
  appUrl.pathname = requested.pathname
  appUrl.search = requested.search
  appUrl.hash = requested.hash
  return appUrl.toString()
}

export function requireWorkflowAppUrl() {
  const value = workflowAppUrl()
  if (!value) throw new Error('生产环境未配置有效的无限画布地址')

  const target = new URL(value)
  if (!['http:', 'https:'].includes(target.protocol)) throw new Error('无限画布地址仅支持 HTTP 或 HTTPS')
  return value
}
